export const checkoutRoute = () => '/booking/checkout'

export const checkoutRouteVehicleStep = () => `${checkoutRoute()}?step=vehicle`
export const checkoutRouteCustomerStep = () => `${checkoutRoute()}?step=contact`
export const checkoutRouteConfirmationStep = () => `${checkoutRoute()}?step=confirmation`
export const checkoutRoutePaymentStep = () => `${checkoutRoute()}?step=payment`
